module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "articleMain"
  }, [_c('div', {
    staticClass: "column relative"
  }, [_c('div', {
    staticClass: "article-header row justify-center items-center relative",
    style: (_vm.headerConfig)
  }, [_c('div', {
    staticClass: "row",
    domProps: {
      "textContent": _vm._s(_vm.headerText)
    }
  }), _vm._v(" "), _vm._t("more")], 2), _vm._v(" "), _c('div', {
    staticClass: "article-container"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42846719"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-components/article/article.vue
// module id = 280
// module chunks = 1